import { render, staticRenderFns } from "./NoWebgl.vue?vue&type=template&id=61148197"
import script from "./NoWebgl.vue?vue&type=script&lang=js"
export * from "./NoWebgl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports